export default "__VITE_ASSET__73370e8a__"